import api from 'app/shared/utils/api';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import LeadsAll from 'app/shared/model/LeadsAll';
import LeadsDetails from 'app/shared/model/LeadsDetails';
import LeadsForListing from 'app/shared/model/LeadsForListing';

const LeadActions = {
    getAllLeads(params = {}, appendToAllLeads = false) {
        return dispatch => dispatch(api.users.leads.allLeads(params))
            .then((result) => {
                if (result.success) {
                    const leadsAllModel = LeadsAll(result.response);
                    const payload = {
                        appendToAllLeads,
                        leadsAllModel,
                    };

                    return dispatch({
                        type: DispatchConstants.LEAD_ALL_LEADS_SUCCESS,
                        payload,
                    });
                }
                return Promise.reject(result.error);
            });
    },
    getLead(params = {}) {
        return dispatch => dispatch(api.users.leads.lead(params))
            .then((result) => {
                if (result.success) {
                    const leadsDetailsModel = LeadsDetails(result.response);

                    return dispatch({
                        type: DispatchConstants.LEAD_SUCCESS,
                        payload: leadsDetailsModel,
                    });
                }

                throw new Error({
                    message: 'message',
                });
            })
            .catch((err) => {
                dispatch({
                    type: DispatchConstants.LEAD_FAIL,
                    payload: err,
                });
                return Promise.reject(err);
            });
    },
    getLeadsForListing(params = {}, appendToInquiries = false) {
        return dispatch => dispatch(api.users.leads.leadsForListing(params))
            .then((result) => {
                if (result.success) {
                    const leadsForListingModel = LeadsForListing(result.response);

                    return dispatch({
                        type: DispatchConstants.LEAD_FOR_LISTING_SUCCESS,
                        payload: {
                            leadsForListingModel,
                            appendToInquiries,
                        },
                    });
                }
                return Promise.reject(result.error);
            })
            .catch(err => dispatch({
                type: DispatchConstants.LEAD_FOR_LISTING_FAIL,
                payload: {
                    success: false,
                    error: err,
                },
            }));
    },
    updateLeadStatus(params = {}) {
        return dispatch => dispatch(api.users.leads.updateLeadStatus(params))
            .then((result) => {
                if (result.success) {
                    return result.response;
                }
                return Promise.reject(result.error);
            })
            .catch(err => new Error(err));
    },
    createFakeLeadForListing(params = {}) {
        return dispatch => dispatch(api.users.leads.createFakeLeadForListing(params))
            .then((result) => {
                if (result.success) {
                    return result.response;
                }
                return Promise.reject(result.error);
            })
            .catch(err => new Error(err));
    },
};

export default LeadActions;
